import getConfig from 'next/config';
import { DOMAIN_PREFIX, domainCode } from '../../constants/staticPageConstants';
const { publicRuntimeConfig } = getConfig();

export const AUTHOR_MAX_LIMIT = 1000;
export const MAX_PARAGRAPH_LIMIT = 5;
export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 1;
export const DEFAULT_DOMAIN = 1;
export const DOMAIN_CODE = publicRuntimeConfig.BASE_URL.domainCode;
export const DOMAIN_HOST_URL_PREFIX =
  (DOMAIN_CODE === domainCode.cleartaxIn ? 'https://' : `https://www.`) +
  `${DOMAIN_PREFIX[DOMAIN_CODE]?.domain}`;

export const SEO_DETAILS = {
  title: `Authors | ${DOMAIN_PREFIX[DOMAIN_CODE]?.name}`,
  metaDesc: `Find ${DOMAIN_PREFIX[DOMAIN_CODE]?.name} author profiles and read their latest articles online at ${DOMAIN_PREFIX[DOMAIN_CODE]?.domain}.`,
  url: `${DOMAIN_HOST_URL_PREFIX}/authors`,
};
